"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.useDataStore = useDataStore;
exports.useDataStores = useDataStores;
exports["default"] = exports.dataStore = void 0;

var _getIterator2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/get-iterator"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/is-array"));

var _iterator8 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/symbol/iterator"));

var _symbol = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/symbol"));

var _from = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/from"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/map"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/typeof"));

var _set = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/set"));

var _json8Patch = _interopRequireDefault(require("json8-patch"));

var _addRecursive = _interopRequireDefault(require("./addRecursive"));

var _react = _interopRequireWildcard(require("react"));

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof _symbol["default"] === "undefined" || o[_iterator8["default"]] == null) { if ((0, _isArray["default"])(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = (0, _getIterator2["default"])(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return (0, _from["default"])(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var _removeListener = function removeListener(repository, pathes, listener) {
  var _iterator = _createForOfIteratorHelper(pathes),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var path = _step.value;

      if (repository.has(path)) {
        repository.get(path)["delete"](listener);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};

var _addListener = function addListener(repository, pathes, listener) {
  var _iterator2 = _createForOfIteratorHelper(pathes),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var path = _step2.value;
      if (!repository.has(path)) repository.set(path, new _set["default"]());
      repository.get(path).add(listener);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
};

var updateStateInComponent = function updateStateInComponent(store, component, state) {
  // if the component has a function to replace pathes
  if (component.mapStoreToState) {
    var updateObj = component.mapStoreToState(store, state); // if the component gets a translated object, apply this and return

    if (updateObj) {
      component.setState(updateObj);
      return;
    }
  } // set the new state to the component without translation


  component.setState(state);
};

function clone(src) {
  function mixin(dest, source, copyFunc) {
    var name,
        s,
        i,
        empty = {};

    for (name in source) {
      // the (!(name in empty) || empty[name] !== s) condition avoids copying properties in "source"
      // inherited from Object.prototype.	 For example, if dest has a custom toString() method,
      // don't overwrite it with the toString() method that source inherited from Object.prototype
      s = source[name];

      if (!(name in dest) || dest[name] !== s && (!(name in empty) || empty[name] !== s)) {
        dest[name] = copyFunc ? copyFunc(s) : s;
      }
    }

    return dest;
  }

  if (!src || (0, _typeof2["default"])(src) != 'object' || Object.prototype.toString.call(src) === '[object Function]') {
    // null, undefined, any non-object, or function
    return src; // anything
  }

  if (src.nodeType && 'cloneNode' in src) {
    // DOM Node
    return src.cloneNode(true); // Node
  }

  if (src instanceof Date) {
    // Date
    return new Date(src.getTime()); // Date
  }

  if (src instanceof RegExp) {
    // RegExp
    return new RegExp(src); // RegExp
  }

  var r, i, l;

  if (src instanceof Array) {
    // array
    r = [];

    for (i = 0, l = src.length; i < l; ++i) {
      if (i in src) {
        r.push(clone(src[i]));
      }
    } // we don't clone functions for performance reasons
    //		}else if(d.isFunction(src)){
    //			// function
    //			r = function(){ return src.apply(this, arguments); };

  } else {
    // generic objects
    r = src.constructor ? new src.constructor() : {};
  }

  return mixin(r, src, clone);
}

var GenericStore = /*#__PURE__*/function () {
  function GenericStore(initialState) {
    (0, _classCallCheck2["default"])(this, GenericStore);
    this.state = initialState || {};
    this.listeners = new _map["default"]();
    this.components = new _map["default"]();
  }

  (0, _createClass2["default"])(GenericStore, [{
    key: "getState",
    value: function getState() {
      return this.state;
    }
  }, {
    key: "addListener",
    value: function addListener(pathes, listener) {
      _addListener(this.listeners, pathes, listener);
    }
  }, {
    key: "addListenerComponent",
    value: function addListenerComponent(pathes, component) {
      _addListener(this.components, pathes, component);

      return this.getValues(pathes);
    }
  }, {
    key: "removeListener",
    value: function removeListener(pathes, listener) {
      _removeListener(this.listeners, pathes, listener);
    }
  }, {
    key: "removeListenerComponent",
    value: function removeListenerComponent(pathes, component) {
      _removeListener(this.components, pathes, component);
    }
  }, {
    key: "setValue",
    value: function setValue(path, value) {
      var dict = {};
      dict[path] = value;
      this.setValues(dict);
    }
  }, {
    key: "setValues",
    value: function setValues(dict) {
      var listenersToCall = new _set["default"](); // of listener functions

      var componentsToUpdate = new _map["default"](); // of reactComponent -> Set of pathes

      for (var _i = 0, _Object$keys = (0, _keys["default"])(dict); _i < _Object$keys.length; _i++) {
        var path = _Object$keys[_i];

        // collect listeners to inform
        var _iterator3 = _createForOfIteratorHelper(this.listeners.keys()),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var listenerPath = _step3.value;
            if (path.startsWith(listenerPath)) listenersToCall.push.apply(listenersToCall, (0, _toConsumableArray2["default"])(this.listeners.get(listenerPath).values()));
          } // collect pathes for components to inform

        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }

        var _iterator4 = _createForOfIteratorHelper(this.components.keys()),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var componentPath = _step4.value;

            if (path.startsWith(componentPath)) {
              var _iterator5 = _createForOfIteratorHelper(this.components.get(componentPath).values()),
                  _step5;

              try {
                for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                  var component = _step5.value;

                  if (!componentsToUpdate.has(component)) {
                    componentsToUpdate.set(component, new _set["default"]());
                  }

                  componentsToUpdate.get(component).add(componentPath);
                }
              } catch (err) {
                _iterator5.e(err);
              } finally {
                _iterator5.f();
              }
            }
          } // change state of this store

        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }

        (0, _addRecursive["default"])(this.state, path, dict[path]);
      } // replace Pathes with values from this actualized store


      var _iterator6 = _createForOfIteratorHelper(componentsToUpdate.keys()),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var _component = _step6.value;
          var newComponentState = this.getValues(componentsToUpdate.get(_component).values());
          componentsToUpdate.set(_component, newComponentState);
        } // call all listeners on nextTick

      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      listenersToCall.forEach(function (listener) {
        setTimeout(listener, 0);
      }); // set state of all Component on nextTick

      var store = this;
      componentsToUpdate.forEach(function (newPartialState, component) {
        setTimeout(function () {
          updateStateInComponent(store, component, newPartialState);
        }, 0);
      });
    }
  }, {
    key: "getValue",
    value: function getValue(path, defaultValue) {
      try {
        var value = _json8Patch["default"].get(this.state, path);

        return value === undefined ? defaultValue : clone(value);
      } catch (_unused) {
        return defaultValue;
      }
    }
  }, {
    key: "getValues",
    value: function getValues(pathes) {
      var partialState = {};

      var _iterator7 = _createForOfIteratorHelper(pathes),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var path = _step7.value;
          var value = this.getValue(path, null);
          (0, _addRecursive["default"])(partialState, path, value);
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }

      return partialState;
    }
  }]);
  return GenericStore;
}();

var dataStore = new GenericStore();
exports.dataStore = dataStore;

function useDataStore(path) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      valueInternal = _useState2[0],
      setValueInternal = _useState2[1];

  var value = dataStore.getValue(path, defaultValue);

  var setValue = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(value) {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return dataStore.setValue(path, value);

            case 2:
              setValueInternal(function (value) {
                return ++value;
              });

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function setValue(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return [value, setValue];
}

function useDataStores(path) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var _useState3 = (0, _react.useState)(0),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      valueInternal = _useState4[0],
      setValueInternal = _useState4[1];

  var values = dataStore.getValues(path, defaultValue);

  var setValues = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(dict) {
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return dataStore.setValues(path, dict);

            case 2:
              setValueInternal(function (value) {
                return ++value;
              });

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function setValues(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  return [values, setValues];
}

var _default = GenericStore;
exports["default"] = _default;